// Single source of truth for the complimentary staging-consultation offer.
// Every placement (homepage hero, home-valuation section, valuation page panel,
// /offers/staging terms page, Terms "Promotions" section) imports from here.
// Do not hard-code this wording anywhere else.

export const OFFER_LINE =
  "List with Doug and get a complimentary one-hour staging consultation with Staging by Connie.*";

export const OFFER_SUMMARY =
  "*Paid for by Doug LeMaire for sellers who list with him. No obligation to buy staging.";

export const OFFER_HEADING = "Complimentary staging consultation — offer details";

export const OFFER_URL = "/offers/staging";

export const OFFER_TERMS = [
  "What's included: a one-hour, in-person consultation at your property with Staging by Connie, with staging recommendations. Furniture rental, décor, and styling or moving labour are not included.",
  "Who pays: paid for by Doug LeMaire, REALTOR®.",
  "Who qualifies: sellers who sign a listing agreement with Doug LeMaire through Fraser Property Management Realty Services Ltd. for a property in Doug's service area (Greater Vancouver, the Fraser Valley and the Sea-to-Sky Corridor).",
  "Minimum listing term: a minimum 90-day listing agreement with Doug LeMaire through Fraser Property Management Realty Services Ltd. is required.",
  "Timing: the consultation must be booked and completed before the listing goes live on the MLS® System (Multiple Listing Service®). The offer ends on that date.",
  "No obligation: you don't have to buy any staging services from Staging by Connie, and you're free to use any stager you choose for your staging.",
  "Independent business: Staging by Connie is an independent business, not part of Fraser Property Management Realty Services Ltd., and is responsible for its own services and advice.",
  "Your information: when you book the consultation, Doug will ask for your written consent before sharing your name, contact details and property address with Staging by Connie. They will be shared only to book your consultation.",
  "The free evaluation is separate: your home evaluation is free whether or not you list or use this offer.",
];
